import { Injectable } from '@angular/core';
import { URL_BASE } from '../../core/constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Report } from './report.model';
import { HttpUtils } from '../../shared/http-utils';
import { map } from 'rxjs/operators';

@Injectable()
export class ReportService {

  private apiUrl = `${URL_BASE}/api/reports`;

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<Report[]> {
    const headers = HttpUtils.createHeaders();
    return this.http.get(`${this.apiUrl}`, {headers})
      .pipe(
        map((result: any[]) => result.map(e => Report.fromDto(e)))
      );
  }

  public getById(reportId: string): Observable<Report> {
    const headers = HttpUtils.createHeaders();
    return this.http.get(`${this.apiUrl}/${reportId}`, {headers})
      .pipe(
        map(c => Report.fromDto(c))
      );
  }

  public create(report: Report): Observable<Report> {
    const headers = HttpUtils.createHeaders();
    return this.http.post(`${this.apiUrl}`, Report.toDto(report), {headers})
      .pipe(
        map(c => Report.fromDto(c))
      );
  }

  public update(report: Report): Observable<Report> {
    const headers = HttpUtils.createHeaders();
    return this.http.put(`${this.apiUrl}/${report.id}`, Report.toDto(report), {headers})
      .pipe(
        map(r => Report.fromDto(r))
      );
  }

  public delete(reportId: string): Observable<boolean> {
    const headers = HttpUtils.createHeaders();
    return this.http.delete<boolean>(`${this.apiUrl}/${reportId}`, {headers})
  }

  public changeHomeReport(homeReport: Report): Observable<Report> {
    const headers = HttpUtils.createHeaders();
    return this.http.put(`${this.apiUrl}/${homeReport.id}/changeHomeReport`, Report.toDto(homeReport), {headers})
      .pipe(
        map(r => Report.fromDto(r))
      );
  }

}
